import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    //
    // POI GUIDE PAGE : PICTURES CAROUSEL
    //
    const splideCarrousel = document.querySelector('.citySplide');

    if (splideCarrousel) {
        new Splide('.splide', {
            type: 'slide',
            perPage: 3,
            autoplay: true,
            interval: 3000,
            rewind: true,
            pagination: false
        }).mount();
    }

    // POI INDEX PAGE : LIENS 'PLUS DE CRITERES'
    const readMoreCriteriaButton = document.getElementById('showContentCriteriaButton');

    if (readMoreCriteriaButton !== null) {
        readMoreCriteriaButton.addEventListener('click', () => {
            readMoreCriteriaButton.classList.toggle('hide');
        })
    }

    // POI INDEX PAGE : LIENS 'Plus de villes'
    const readMoreCitiesButton = document.getElementById('showContentCitiesButton');

    if (readMoreCitiesButton !== null) {
        readMoreCitiesButton.addEventListener('click', () => {
            readMoreCitiesButton.classList.toggle('hide');
        })
    }

    // POI INDEX PAGE : LIENS 'Plus de rubriques'
    const readMoreSubcategoriesButton = document.getElementById('showContentSubcategoriesButton');

    if (readMoreSubcategoriesButton !== null) {
        readMoreSubcategoriesButton.addEventListener('click', () => {
            readMoreSubcategoriesButton.classList.toggle('hide');
        })
    }

    // POI INDEX PAGE : LIENS 'Plus de quartiers'
    const readMoreMetrosButton = document.getElementById('showContentMetrosButton');

    if (readMoreMetrosButton !== null) {
        readMoreMetrosButton.addEventListener('click', () => {
            readMoreMetrosButton.classList.toggle('hide');
        })
    }

    // POI INDEX PAGE : LIENS 'Plus d'arrondissements'
    const readMoreDistrictsButton = document.getElementById('showContentDistrictsButton');

    if (readMoreDistrictsButton !== null) {
        readMoreDistrictsButton.addEventListener('click', () => {
            readMoreDistrictsButton.classList.toggle('hide');
        })
    }

    //
    // POI SHOW PAGE : PICTURES CAROUSEL
    // TODO : SUPPRIMER SI VRAIMENT PAS UTILISÉ
    // const splideCarrouselPoi = document.querySelector('.poiSplide');
    //
    // if (splideCarrouselPoi) {
    //     let splidePrimary = new Splide('.splide', {
    //         type: 'fade',
    //         perPage: 1,
    //         classes: {
    //             arrows: 'splide__arrows poi-modal-arrows',
    //             pagination: 'splide__pagination poi-modal-pagination'
    //         }
    //     }).mount();
    //     let splideSecondary = new Splide('.splide-legend', {
    //         type: 'fade',
    //         perPage: 1,
    //         arrows: false,
    //         pagination: false
    //     });
    //
    //     splideSecondary.sync(splidePrimary).mount();
    //
    // }
});



